import Divider from '@mui/material/Divider';

import { ListBulkAddFooter } from './components/ListBulkAddFooter/ListBulkAddFooter.tsx';
import { ListHeaderActions } from './components/ListHeaderActions/ListHeaderActions.tsx';
import { ListRoot } from './components/ListRoot/ListRoot.tsx';
import { ListTopBar } from './components/ListTopBar/ListTopBar.tsx';
import { ListVirtualized } from './components/ListVirtualized/ListVirtualized.tsx';

export const List = {
  BulkAddFooter: ListBulkAddFooter,
  Content: ListVirtualized,
  Divider: Divider,
  HeaderActions: ListHeaderActions,
  Root: ListRoot,
  TopBar: ListTopBar,
};
